import React, { FunctionComponent } from 'react';
import { StyledComponent } from 'styled-components';

import Loader from '../../Loader';
import StyledButtonContent from '../styled/StyledButtonContent';
import onClickProps from '../../../utils/onClickProps';
import { ButtonProps } from '../types';

type ButtonComponentProps = Omit<
  ButtonProps,
  'link' | 'children' | 'onClick' | 'showAsDisabled'
> & { onKeyPress?: React.KeyboardEventHandler };

type LinkComponentProps = Omit<
  ButtonProps,
  'link' | 'children' | 'onClick' | 'showAsDisabled'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
> & { onKeyPress?: React.KeyboardEventHandler<any> };

const makeButton =
  (
    ButtonComponent: StyledComponent<
      React.ComponentType<ButtonComponentProps>,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any
    >,
    LinkComponent: React.ComponentType<LinkComponentProps> | null = null,
    linkComponentProp = 'href',
  ): FunctionComponent<ButtonProps> =>
  props => {
    const { link, children, onClick, showAsDisabled, disabled, ...rest } =
      props;
    if (LinkComponent && link) {
      return (
        <LinkComponent
          disabled={disabled || showAsDisabled}
          {...{ [linkComponentProp]: link }}
          {...onClickProps(onClick, disabled)}
          {...rest}
        >
          <StyledButtonContent>{children}</StyledButtonContent>
        </LinkComponent>
      );
    }

    return (
      <ButtonComponent
        disabled={disabled || showAsDisabled}
        {...onClickProps(onClick, disabled)}
        {...rest}
      >
        {props.submitting && <Loader />}
        <StyledButtonContent>{children}</StyledButtonContent>
      </ButtonComponent>
    );
  };

export default makeButton;
